<template>
    <div>
        <Head :titulo="titulo" />
        <div class="hero-bloque-mascara">
            <div class="hero-bloque-mascara__img">
                <img src="/img/hero-bloque-img-mascara.png" alt="">
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-md-7">
                        <h1 class="hero-encabezado">{{ servicio.nombre }}</h1>
                        <div class="hero-etiquetas">
                            <span class="badge etiqueta-simple">Trámite en Línea</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Head from '../../../Shared/Head.vue';

export default {
    props: {
        servicio: Object,
    },
    components: {
        Head
    },
    computed: {
        titulo(){
            return 'Formulario para '+this.servicio.nombre;
        }
    }
}
</script>
